import { Button, XIcon } from '@integration/alexandria-ui';
import { useTranslateByProject } from 'hooks/translation-hooks';
import type { ChangeEvent, FunctionComponent } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import modalActions from 'redux/actions/modalActions';
import {
  ButtonContainer,
  Container,
  Content,
  Header,
  Separator,
} from './styled';
import { TextAreaField } from 'components/TextArea/TextArea.styled';
import { reportABug } from 'redux/actions/reportABugActions';

const TEST_ID = 'report_a_bug_modal';

const CATEGORY = 'report_a_bug_modal-';
const ReportABug: FunctionComponent = () => {
  const t = useTranslateByProject();
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(modalActions.hideModalV2());
  };

  const handleCloseIconClick = () => {
    closeModal();
  };

  const onPrimaryButtonClick = () => {
    dispatch(
      reportABug({
        message: text,
        errorMessage: t(CATEGORY + 'error_message'),
        successMessage: t(CATEGORY + 'success_message'),
      }),
    );
    closeModal();
  };

  const [text, setText] = useState('');
  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    e.target.value = e.target.value.substring(0, 2000);
    setText(e.target.value);
  };

  return (
    <Container data-testid={`${TEST_ID}-container`}>
      <Header>
        <h1>{t(CATEGORY + 'title')}</h1>
        <XIcon
          data-testid={`${TEST_ID}-close_btn`}
          onClick={handleCloseIconClick}
        />
      </Header>
      <Separator />
      <Content>{t(CATEGORY + 'content')}</Content>
      <TextAreaField
        data-testid={`${TEST_ID}-textarea`}
        onChange={onChange}
        placeholder={t(CATEGORY + 'textarea-placeholder')}
        value={text}
      />
      <Separator />
      <ButtonContainer>
        <Button
          dataTestId={`${TEST_ID}-send_btn`}
          onClick={onPrimaryButtonClick}
        >
          {t(CATEGORY + 'send_button')}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default ReportABug;
